import React from "react";
import { Button, ListItem,  ListItemText, List, Divider } from '@mui/material';




const InvestigationsCard = (props) => {
    
var {nhtsaIdNumber, subject, summary, associatedProductsCount, associatedDocumentsCount} = props;

return (
    <List
        sx={{
            margin: 0,
            padding: 0,
            width: '100%',
            borderRadius: 0,
            borderColor: 'divider',
            //backgroundColor: '#ebe3e3',
            //p8Ozz44B5-MIXViQ3rOk
        }}
        
    >
        <ListItem>
            <ListItemText primary={`${subject}`} secondary= {`${summary?.substr(0, 150)}...`} />
        </ListItem>
        <ListItem>
            <ListItemText primary="NHTSA Number" secondary= {`${nhtsaIdNumber}`} />
            <ListItemText primary="Affected Products" secondary= {`${associatedProductsCount}`} />
            <ListItemText primary="Associated Documents" secondary= {`${associatedDocumentsCount}`} />
            <Button>View Details</Button>
        </ListItem>
        
    </List>
)}

export default InvestigationsCard;